













import { Vue, Component } from "vue-property-decorator";
import messageService from "@/services/MessageService";
import { Message } from "@/services/MessageService";

@Component
export default class SnackBar extends Vue {
  close = messageService.close;
  clear = messageService.clear;
  show: boolean = false;

  messages = messageService.messages;
  lastMessage = messageService.lastMessage;

  updated() {
    if (!this.show && this.messages.length > 0) {
      this.show = true;
    } else {
      if (this.show && this.messages.length == 0) {
        this.show = false;
      }
    }
  }
}
